export const folderCarePlanUserFrag = `
    id
    name
    surname
    email
    titleAfterName
    titleBeforeName
`;

export const folderCarePlanFrag = `
    id
    data
    symptoms
    createdAt
    user {
        ${folderCarePlanUserFrag}
    }
`;
